import {
  Box,
  Card,
  Divider,
  Icons,
  Stack,
  styled,
  Text,
  Button,
} from '@/theme/index';

interface OnboardingTaskProps {
  /** The text to display for the task. */
  taskText: string;
  /** The text to display for the task when is completed. */
  completedTaskText: string;
  /** The icon to display next to the text. */
  icon: JSX.Element;
  /** A flag indicating if the task is completed. */
  completed?: boolean;
  /** A flag indicating whether to display a divider below the task. */
  divider?: boolean;
}

/**
 * This component displays a task with an optional completion indicator and a divider.
 */
export function OnboardingTask({
  taskText,
  completedTaskText,
  icon,
  completed,
  divider = true,
}: OnboardingTaskProps) {
  return (
    <>
      <Stack
        direction="row"
        color={(theme) =>
          completed
            ? theme.palette.threatDetection?.dark
            : theme.palette.primary.main
        }
        justifyContent="space-between"
        alignItems="center"
        gap={1}
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          {icon}
          <Text ml={1}>{completed ? completedTaskText : taskText}</Text>
        </Box>
        {completed && <Icons.CheckCircle fontSize="small" />}
      </Stack>
      {divider && (
        <Divider
          sx={(theme) => ({
            borderColor: theme.palette.secondary.main,
          })}
        />
      )}
    </>
  );
}

export const OnboardingTaskCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.threatDetection?.dark,
  backgroundColor: theme.palette.secondary.main,
  width: '100%',
  border: 'none',
}));

export const CustomCheckListButton = styled(Button)(({ theme }) => ({
  paddingY: theme.spacing(1),
  alignItems: 'center',
  width: '100%',
  color: theme.palette.primary.contrastText,
}));

export const OnboardingChecklistContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.secondary.main}`,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
  [theme.breakpoints.up('lg')]: {
    maxWidth: '25%',
    flexBasis: '25%',
  },
}));
